import { BASE_PATH } from '@/lib/basePath'
import { isMockInterviewPath } from '@/lib/mockInterviewEntry'

function appPathname(pathname: string | null): string {
  if (pathname == null) return ''
  if (BASE_PATH && pathname.startsWith(BASE_PATH)) {
    const rest = pathname.slice(BASE_PATH.length)
    return rest === '' ? '/' : rest
  }
  return pathname
}

/** Direct-URL campaign landings that render their own header/footer. */
export const CAMPAIGN_PATHS = [
  '/data-analytics-engineering',
  '/cloud-devops-platform-engineering',
  '/security-engineering',
  '/mlops-forward-deployed-engineering',
] as const

export function shouldHideSupportFab(pathname: string | null): boolean {
  const p = appPathname(pathname)
  if (!p) return false
  // Hide during active interview flows
  if (p === '/interview' || p.startsWith('/interview/')) return true
  if (isMockInterviewPath(p)) return true
  if (p === '/jd-interview' || p.startsWith('/jd-interview/')) return true
  if (p === '/system-design-interview' || p.startsWith('/system-design-interview/')) return true
  if (p === '/skill-assessment' || p.startsWith('/skill-assessment/')) return true
  if (p === '/interview-intro' || p.startsWith('/interview-intro/')) return true
  // Hide on payment/checkout flows
  if (p === '/payment' || p.startsWith('/payment/')) return true
  if (p === '/checkout' || p.startsWith('/checkout/')) return true
  // Hide on invoice preview
  if (p === '/invoice-preview' || p.startsWith('/invoice-preview/')) return true
  // Hide on interview results/summary pages
  if (p === '/results' || p.startsWith('/results/')) return true
  if (p === '/interview-summary' || p.startsWith('/interview-summary/')) return true
  // Hide on transaction history pages
  if (p === '/my-transactions' || p.startsWith('/my-transactions/')) return true
  // Hide across all enterprise flows
  if (p === '/enterprise' || p.startsWith('/enterprise/')) return true
  if (p === '/enterprise-auth' || p.startsWith('/enterprise-auth/')) return true
  // Hide on interview history/summary pages
  if (p === '/history' || p.startsWith('/history/')) return true
  if (p === '/question-review' || p.startsWith('/question-review/')) return true
  // Hide on profile and referral pages
  if (p === '/user-profile' || p.startsWith('/user-profile/')) return true
  if (p === '/referral' || p.startsWith('/referral/')) return true
  // Hide on the free mock interview campaign landing page
  if (p === '/free-15-minute-mock-interview' || p.startsWith('/free-15-minute-mock-interview/')) return true
  // Hide on the Dussehra campaign landing — it has its own header and footer
  if (p === '/dussehra-offer' || p.startsWith('/dussehra-offer/')) return true
  // Hide on role/track interview-practice campaign landings (shared layout)
  // Campaign landers render their own chrome; keep the support FAB off them.
  if (CAMPAIGN_PATHS.some((path) => p === path || p.startsWith(`${path}/`))) return true
  // Hide on the QR landing page reached from printed material
  if (p === '/overview' || p.startsWith('/overview/')) return true
  return false
}
